export default [
  {
    key: 'id',
    label: '#ID',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: false,
  },
  {
    key: 'source_name',
    label: 'File Name',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'user',
    label: 'Uploaded By',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
    type: 'object',
    object: {
      key: 'user',
      property: 'name',
    },
  },
  {
    key: 'created_at',
    label: 'Uploaded At',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
    type: 'date',
  },
  {
    key: 'size',
    label: 'Size',
    sortable: false,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'action',
    label: '',
    sortable: false,
    show: true,
    type: 'action_list',
    tdClass: 'actions',
    thStyle: { width: '160px' },
    class: 'text-center align-middle text-capitalize',
    thClass: 'align-middle text-center',
    actions: [
      {
        icon: 'download',
        title: 'Download',
        event: 'download',
      },
      {
        icon: 'eye',
        title: 'View PDF',
        event: 'readPdf',
      },
    ],
  },
]
